<template>
<v-container>
	<!--Step 2-->
  <v-card id="popStyle02" class="popWgeust" v-if="changeMemdialog" >
	  <v-row no-gutters class="scrollYst popConH100-1row">
		<v-row no-gutters class="scrollYst_con">
			<v-col cols="12">
				안정적인 전자계약 서비스, 글로싸인엔터프라이즈 회원으로 간편하게 전환하기 위한 아래의 정보를 입력하세요.
			</v-col>
			<v-col cols="12" class="pt-4">
				<div class="popCon_input_W100_cov row_mt-20">
					<v-text-field class="inputH48_01"
						label="이메일"
						placeholder="이메일 변경 못함"
						outlined
						dense
						disabled
						v-model="accountform.email"
					>
					</v-text-field>
				</div>
			</v-col>
			<v-col cols="12" class="pt-4">
				<div class="popCon_input_W100_cov">
					<!--<div class="signup_pic_cov">
							<div class="label_st00 mb-2">프로필 사진</div>
							<div class="org_pic_cov">
								<div class="org_pic"></div>
								<v-btn class="btnO_C01 edit_pic" @click="dialogImg = true"><span class="icon"></span></v-btn>
							</div>
					</div>-->
					<div><!-- class="signup_info_cov"-->
						<v-form ref="accountform" v-model="valid" lazy-validation>
					<v-row no-gutters>
						<v-col cols="12">
							<v-text-field class="inputH48_01 inputH48_left_btn_before conBstar"
							label="아이디"
							placeholder="사용할 아이디 입력"
							v-model="accountform.userid"
							:rules="rules.useridRules"
							outlined
							dense
							>
							</v-text-field>
							<v-btn text class="btn17_C01" @click="isValidID">ID중복검사</v-btn>
							<div v-if="this.accountform.userid !== '' && this.isCheckId === this.accountform.userid && !this.isAlreadyUse" class="signup_info_txtOK">사용가능한 아이디입니다</div>
							<div v-if="this.accountform.userid !== '' && this.isCheckId !== this.accountform.userid && this.isAlreadyUse" class="signup_info_txtNo">사용불가능한 아이디입니다</div>
						</v-col>
						<v-col cols="12">
							<v-text-field class="inputH48_01 W90 conBstar"
								label="비밀번호"
								placeholder="영어, 숫자 포함. 6~12자리로 입력"
								outlined
								dense
								v-model="accountform.password"
								:type="'password'"
								:rules="rules.passwordRules"
							>
							</v-text-field>
						</v-col>
						<v-col cols="12">
							<v-text-field class="inputH48_01 W90 conBstar"
								label="비밀번호 확인"
								placeholder="영어, 숫자 포함. 6~12자리로 입력"
								outlined
								dense
								v-model="accountform.password_re"
								:type="'password'"
								:rules="[(accountform.password === accountform.password_re) || '비밀번호가 일치하지않습니다']"

							>
							</v-text-field>
						</v-col>
						<v-col cols="12">
							<v-text-field class="inputH48_01 W90 conBstar"
								label="이름"
								placeholder="사용자 이름"
								outlined
								dense
								v-model="accountform.name"
								:rules="rules.nameRules"
							>
							</v-text-field>
						</v-col>
						<v-col cols="12">
							<v-text-field class="inputH48_01 W90 conBstar"
								label="연락처"
								placeholder="SMS 수신용 휴대폰번호"
								outlined
								dense
								v-model="accountform.phone"
								:rules="rules.phoneRules"
							>
							</v-text-field>
						</v-col>
						<v-col cols="12" class="posiR">
							<v-checkbox
					v-model="accountform.term_use"
					@change="termUse"
					></v-checkbox>
					<label class="chk_label">글로싸인엔터프라이즈의 <span class="btn_a" @click="dialogAgree = true">이용약관 및 개인정보처리방침</span>에 동의합니다.</label>
						</v-col>
						<v-col cols="12" class="posiR">
							<!--v-model 변경해야됨-->
							<v-checkbox
							v-model="accountform.term_use_sw"
							@change="termUseSw"
							></v-checkbox>
							<label class="chk_label">글로싸인엔터프라이즈 <span class="btn_a" @click="dialogPass = true">간편 회원 전환 처리의 내용</span>에 동의합니다.</label>
						</v-col>
					</v-row>
									</v-form>
						</div>
					</div>
				</v-col>
			</v-row>
		</v-row>
		<v-card-actions class="justify-center signup_btnCon">
			<v-btn outlined class="btn19_00 btnC_01 btn_bottom_W314" @click="submitForm('accountform')">간편 회원 가입</v-btn>
			<!--다음으로 이동-->
		</v-card-actions>
	</v-card>
	<!--/Step 2-->

	<!--(팝업)이용약관 및 개인정보처리방침-->
	<v-dialog title="이용약관 및 개인정보처리방침" v-model="dialogAgree" width="472" append-to-body>
		<v-card id="popStyle03">
			<v-card-text class="signup-text_in_Con">
				<div class="pt-6">
					<div class="dot_tt16 mb-2">이용약관</div>
					<div class="signU_rule_box H02">
						<div class="agreePage ruleboxst">
							<v-row no-gutters>
								<!--시행중인 이용약관 보기-->
								<v-col cols="12" class="agreePage">
									<h3 class="agree_h1">제 1 장 총칙</h3>
									<ul class="agree_list">
										<li>
											<h4 class="agree_h2">제 1 조 (약관의 목적)</h4>
											<p class="agree_p">이 약관은 주식회사 ㈜비즈니스온커뮤니케이션(이하 "회사"라 한다)이 제공하는 글로싸인엔터프라이즈서비스(이하 "서비스"라 한다)를 이용함에 있어서 회사와 서비스이용자(이하 "회원"이라 한다)간에 서비스 이용의 방법 및 기타 필요한 사항을 규정함을 목적으로 합니다.</p>
										</li>
										<li>
											<h4 class="agree_h2">제 2 조 (약관의 효력 및 변경)</h4>
											<ul class="agree_in">
												<li>① 이 약관은 회사의 서비스 사이트(sign.smartbill.co.kr)에 게시하여 공지하거나 전자우편, 기타의 방법으로 회원에게 통지함으로써 효력을 발생합니다.</li>
												<li>② 회사는 제공하게 되는 새로운 서비스의 적용, 보안체계의 향상 및 유지, 정부에 의한 시정명령의 이행 등 기타 회사의 업무상 약관을 변경하여야 할 중요한 사유가 있다고 판단될 경우 약관을 변경할 수 있으며, 변경된 약관은 제1항과 같은 방법으로 공지 또는 통지함으로써 효력을 발생합니다.</li>
												<li>③ 변경된 약관의 공시된 날로부터 1개월 이내에 회원이 회사에 서면으로 이의를 제기하지 아니한 때에는 변경된 약관을 승인한 것으로 간주하며, 이의를 제기하는 경우 회사는 회원과 협의를 거친 후 수용여부를 결정합니다.</li>
												<li>④ 약관의 내용은 회사의 서비스 사이트에 항상 게시됩니다.</li>
											</ul>
										</li>
										<li>
											<h4 class="agree_h2">제 3 조 (명시되지 않은 약관의 적용)</h4>
											<p class="agree_p">이 약관에 명시되지 아니한 사항은 관계법령 및 기타관습에 따릅니다.</p>
										</li>
										<li>
											<h4 class="agree_h2">제 4 조 (용어의 정의)</h4>
											<ul class="agree_in">
												<li>① 글로싸인엔터프라이즈: 블록체인 기반의 전자계약 서비스를 말합니다.</li>
												<li>② 전자계약 : 오프라인에서 주고받던 계약서를 인터넷상에서 온라인으로 주고받는 계약서를 말합니다.</li>
												<li>③ 회원 : 회사와 이용계약을 체결한 이용자로서 처음 가입한 자는 관리자로 설정됩니다.<br/>
													<ul class="agree_in02">
														<li>- 관리자 : 기업을 대표하여 최초로 가입하는 회원이며 회사의 모든 권한과 책임을 부여 받습니다. </li>
													</ul>
												</li>
												<li>④ 아이디(ID) : 회원식별과 서비스 이용을 위하여 회원이 선정하고 회사가 승인한 문자와 숫자의 조합입니다.</li>
												<li>⑤ 비밀번호(PW) : ID에 대하여 사용자임을 확인하고 회원 자신의 비밀 보호를 위하여 회원이 선정하고 회사가 승인한 문자와 숫자의 조합입니다.</li>
												<li>⑥ 블록체인 계정주소 : 블록체인 네트워크 상에서 이용자 식별을 위한 문자열로, 블록체인 네트워크 상에서 생성되어 제공됩니다.</li>
												<li>⑦ 블록체인 계정주소의 비밀번호 (이하 블록체인 비밀번호) : 블록체인 계정주소의 사용자임을 확인하고 회원 자신의 비밀 보호를 위하여 회원이 선정하고 회사가 승인한 문자와 숫자의 조합입니다.</li>
											</ul>
										</li>
									</ul>
									<h3 class="agree_h1">제 2 장 서비스 이용 신청</h3>
									<ul class="agree_list">
										<li>
											<h4 class="agree_h2">제 5 조 (이용 신청)</h4>
											<ul class="agree_in">
												<li>① 본 서비스 이용 희망 개인은 서비스 사이트에 접속하여 회원으로 가입함으로써 회사와 서비스 이용계약이 성립됩니다.</li>
												<li>② 회원가입은 이용 희망 개인이 서비스의 이용약관에 동의한 후, 온라인 회원가입 신청서에 개인의 정보를 기재하여 신청하고, 이에 대하여 회사가 승인함으로써 성립합니다.</li>
												<li>③ 본 서비스 이용 희망 기업은 기업의 대표 관리자가 본 서비스를 통하여 회사와 서비스 신청 계약을 체결함으로써 이용계약이 성립됩니다.</li>
												<li>④ 서비스 신청 계약 시 사업자등록증 사본과 법인인감증명서 원본이 첨부되어야 합니다.</li>
												<li>⑤ 회원가입 신청서 및 서비스 신청 계약서에 입력한 이용 개인의 정보는 모두 실제 데이터로 간주되며, 허위정보임이 판명되면 서비스의 제한을 받을 수 있습니다.</li>
											</ul>
										</li>
									</ul>
									<h3 class="agree_h1">제 3 장 서비스의 제공 및 이용</h3>
									<ul class="agree_list">
										<li>
											<h4 class="agree_h2">제 6 조 (서비스의 제공)</h4>
											<ul class="agree_in">
												<li>① 회사가 회원에게 제공하는 서비스 내용은 다음 각 호와 같습니다.
													<ul class="agree_in02">
														<li>- 전자계약의 작성 및 계약요청 서비스</li>
														<li>- 전자계약의 조회 및 승인 서비스</li>
														<li>- 전자계약의 이력 조회 서비스</li>
														<li>- 블록체인 전자서명을 통한 전자문서 서명 서비스</li>
														<li>- 블록체인 인증을 통한 전자문서의 진본 확인 서비스</li>
													</ul>
												</li>
											</ul>
										</li>
										<li>
											<h4 class="agree_h2">제 7 조 (서비스의 이용)</h4>
											<ul class="agree_in">
												<li>① 서비스는 제5조에 의거하여 가입을 완료한 시점부터 즉시 이용할 수 있습니다. 이용요금에 대한 결제가 정상적으로 이루어진 회원에 한하여 이용이 가능합니다. </li>
												<li>② 서비스의 이용시간은 연중무휴 1일 24시간을 원칙으로 하며, 다만 다음 각 호에 해당하는 경우는 예외로 합니다.
													<ul class="agree_in02">
														<li>- 정기점검, 서비스 이용향상 등을 위해 회사가 정한 날이나 시간</li>
														<li>- 시스템 장애, 서비스 이용의 폭주, 천재지변으로 인한 서비스의 중단</li>
														<li>- 위의 각 호에 준하는 경우</li>
													</ul>
												</li>
												<li>③ 회사는 이용시간을 제한하는 경우 그 내용을 사전에 사이트를 통해  공지하여야 합니다.</li>
											</ul>
										</li>
										<li>
											<h4 class="agree_h2">제 8 조 (블록체인 계정주소과 비밀번호의 관리)</h4>
											<ul class="agree_in">
												<li>① 회원 개인과 기업의 고유한 블록체인 계정주소는 시스템(블록체인 네트워크)에서 자동 생성 되며, 회원가입과 기업등록(생성)을 통해 발급됩니다.</li>
												<li>② 블록체인 계정주소는 최초 생성 후에 변경할 수 없습니다.</li>
												<li>③ 블록체인 비밀번호는 블록체인 계정주소 최초 생성시 회원이 직접 설정하며, 변경 할 수 있습니다. 다만, 이에 대한 관리는 전적으로 회원이 책임지고 관리해야 합니다.</li>
												<li>④ 블록체인 비밀번호는 시스템에서 확인하거나, 시스템관리자가 재설정 할 수 없으며, 비밀번호 분실 시 전자계약을 생성하거나, 승인할 수 없습니다.</li>
											</ul>
										</li>
										<li>
											<h4 class="agree_h2">제 9 조 (전자문서/전자서명 법적 효력)</h4>
											<ul class="agree_in">
												<li>① 전자문서 및 전자거래 기본법 제4조 제1항에 의해 전자적 형태로 되어 있다는 이유로 문서로서의 효력이 부인되지 않지만 다른 법령에 특별한 규정이 있는 경우 법적 효력이 인정되지 않을 수 있으며 이와 관련되어 발생하는 문제에 대해서 책임지지 않습니다.</li>
												<li>② 전자서명에 사용되는 서명은 전자서명법 제3조 제3항에 의해 당사자간의 약정에 따른 서명, 서명날인 또는 기명 날인으로서의 효력을 가지지만 다른 법령에 특별한 규정이 있는 경우 법적 효력이 인정되지 않을 수 있으며 이와 관련되어 발생하는 문제에 대해서 책임지지 않습니다.</li>
											</ul>
										</li>
									</ul>
									<h3 class="agree_h1">제 4 장 회원정보의 관리</h3>
									<ul class="agree_list">
										<li>
											<h4 class="agree_h2">제 10 조 (회원정보의 수집 및 이용목적)</h4>
											<ul class="agree_in">
												<li>① 회원으로 가입하여 서비스를 이용하고자 하는 이용자는 회사에서 요청하는 제반 정보(회사명, 대표자명, 사업자등록번호, 이용자ID, 비밀번호, 이름, 연락처 등)를 제공하여야 합니다. 또한 지능형 집계 정보 제공 서비스를 위해 6조 1항의 서비스 사용시 발생하는 세부 내역 데이터 등 기타 정보를 상황에 따라 수집할 수 있습니다.</li>
												<li>② 모든 회원은 반드시 회원 본인의 정보를 제공하여야만 서비스를 이용할 수 있으며, 타인의 정보를 도용하거나 허위의 정보를 등록하는 등 본인의 진정한 정보를 등록하지 않은 회원은 서비스 이용과 관련하여 아무런 권리를 주장할 수 없으며, 관계 법령에 따라 처벌 받을 수 있습니다.</li>
												<li>③ 회원가입은 반드시 본인의 진정한 정보를 통하여만 가입할 수 있으며 회사는 회원이 등록한 정보에 대하여 확인조치를 할 수 있습니다. 회원은 회사의 확인조치에 대하여 적극 협력하여야 하며, 만일 이를 준수하지 아니할 경우 회사는 회원이 등록한 정보가 부정한 것으로 처리할 수 있습니다. </li>
											</ul>
										</li>
										<li>
											<h4 class="agree_h2">제 11 조 (회원정보의 보호)</h4>
											<ul class="agree_in">
												<li>① 당사는 수집된 회원정보가 분실, 도난 , 누출 , 변조 또는 훼손되지 아니하도록 보안 및 안정성 확보에 필요한 기술적 조치 등을 취하여야 합니다.</li>
												<li>② 당사는 서비스와 관련하여 취득한 회원의 개인정보를 본인의 사전 승낙 없이 타인에게 누설, 공개 또는 배포할 수 없으며, 서비스 관련 업무 이외의 상업적 목적으로 사용할 수 없습니다. <br/>
												다만, 다음 각 호의 해당하는 경우에는 그러하지 아니합니다
													<ul class="agree_in02">
														<li>1. 관계법령에 의하여 수사상의 목적으로 관계기관으로부터 요구 받은 경우.</li>
														<li>2. 정보통신윤리위원회의 요청이 있는 경우.</li>
														<li>3. 서비스 제공에 따른 요금정산을 위하여 필요한 경우.</li>
														<li>4. 통계작성, 학술연구 또는 시장조사를 위하여 필요한 경우로서 특정 개인을 식별할 수 없는 형태로 제공하는 경우.</li>
														<li>5. 본 서비스에 기업정보 및 개인신용평가를 제공하는 신용정보사업자의 요청이 있는 경우.</li>
														<li>6. 기타 관계법령에 의한 경우.</li>
													</ul>
												</li>
												<li>③ 제2항의 범위 내에서 당사는 광고업무와 관련하여 회원 전체 또는 일부의 개인정보에 관한 통계자료를 작성하여 이를 사용할 수 있고, 서비스를 통하여 회원의 컴퓨터에 쿠키를 전송할 수 있습니다. 이 경우 회원은 쿠키의 수신을 거부하거나 쿠키의 수신에 대하여 경고하도록 컴퓨터 브라우저의 설정을 변경할 수 있습니다.</li>
											</ul>
										</li>
										<li>
											<h4 class="agree_h2">제 12 조 (회원이용정보 및 자료의 보호)</h4>
											<ul class="agree_in">
												<li>① 회사는 회원이 제공한 회원정보를 서비스 이용기간동안 보유하며, 회원 탈퇴시에는 회원정보를 관련법규에 따라 보존할 의무가 없는 한 즉시 폐기합니다.</li>
												<li>② 회원 가입 시 제공한 회원의 정보는(이름, 전자메일 주소, 연락처 등)글로싸인엔터프라이즈 모든 서비스의 원활한 운영을 위해, 경우에 따라 공유될 수 있습니다. (단, 비밀번호는 절대 공유불가)</li>
											</ul>
										</li>
										<li>
											<h4 class="agree_h2">제 13 조 (각종 정보의 제공 및 광고성 정보수신 동의)</h4>
											<ul class="agree_in">
												<li>① 회사는 회원에게 회사의 서비스 및 각종 행사 소개와 안내를 서신우편물, 전화, FAX, E-Mail, SMS, 기타 스마트폰 알림서비스 등을 통해 제공할 수 있습니다.</li>
												<li>② 회원은 회사 및 회사의 제휴업체가 정보통신망 이용촉진 및 정보보호에 관한 법률 제50조 제2항에 따라 회원의 전화, FAX, E-Mail, SMS, 기타 스마트폰 알림서비스 등을 통하여 광고성 정보를 전송하는데 동의합니다.</li>
												<li>③회원의 개인정보는 관련 법률이 정하는 바에 따라 엄격히 관리되며, 회원은 원하지 않는 경우 회사가 제공하는 서비스 정보 또는 광고성 정보의 수신을 거부할 수 있습니다. </li>
											</ul>
										</li>
										<li>
											<h4 class="agree_h2">제 14 조 (ID 부여 및 변경)</h4>
											<ul class="agree_in">
												<li>① ID는 다음 각 호에 해당하는 경우 회원 또는 회사의 요청에 의하여 변경할 수 있습니다.<br/>
													<ul class="agree_in02">
														<li>- ID가 회원의 사생활 침해가 우려가 있는 경우</li>
														<li>- 타인에게 혐오감을 주거나 미풍양속에 어긋나는 경우</li>
														<li>- 기타 합리적인 사유가 있는 경우</li>
													</ul>
												</li>
												<li>② ID 변경은 불가능하며 비밀번호는 수시로 변경할 수 있습니다. 다만, 이에 대한 관리는 전적으로 회원이 책임지고 관리해야 합니다.</li>
												<li>③ 회원은 ID와 비밀번호를 통하여 전자계약 조회만 가능하고 전자계약 요청 및 승인은 블록체인 인증을 통해 이용할 수 있습니다. </li>
											</ul>
										</li>
										<li>
											<h4 class="agree_h2">제 15 조 (게시물의 관리)</h4>
											<ul class="agree_in">
												<li>① 회사는 회원이 게시하거나 등록한 내용이 다음 각 호에 해당한다고 판단되는 경우 회원에게 사전 통지나 동의없이 게시물을 삭제할 수 있으며, 게시물의 검열, 검색에 따른 어떠한 의무와 게시물의 내용 및 관리에 따른 일체의 손해배상책임을 부담하지 않습니다. <br/>
													<ul class="agree_in02">
														<li>- 다른 회원 또는 제3자를 비방하거나 중상모략으로 명예를 손상시키는 내용인 경우</li>
														<li>- 공공 질서 및 미풍양속에 위반되는 내용인 경우</li>
														<li>- 범죄적 행위와 결부된다고 판단되는 내용인 경우</li>
														<li>- 제3자의 저작권 등 기타 권리를 침해하는 내용인 경우</li>
														<li>- 광고성 글이나 음란물 등 사이트의 이용목적에 부합하지 않는 경우</li>
														<li>- 기타 관계법령에 위배되거나 위배될 우려가 있는 경우</li>
													</ul>
												</li>
												<li>② 회원은 서비스를 이용하여 얻은 정보를 가공, 판매하는 행위 등 게재된 자료를 상업적으로 이용할 수 없으며 이를 위반하여 발생하는 제반문제의 책임은 회원에게 있습니다.</li>
											</ul>
										</li>
										<li>
											<h4 class="agree_h2">제 16 조 (쿠키(Cookie)의 운용 및 활용)</h4>
											<p class="agree_p">회회사는 회원에게 적합하고 유용한 서비스를 제공하기 위해서 회원의 정보를 저장하고 수시로 불러오는 쿠키(cookie)를 사용합니다.<br/>
											또한 회사는 업무와 관련하여 회원전체 또는 일부의 개인정보에 관한 통계자료를 작성하여 이를 사용할 수 있으며, 서비스를 통하여 회원의 컴퓨터에 쿠키를 전송할 수 있습니다.<br/>
											이 경우 회원은 선택권을 가지고 있어 쿠키의 수신을 거부하거나 쿠키의 수신에 대하여 경고하도록 사용하는 컴퓨터 브라우저의 설정을 변경할 수 있습니다.<br/>
											단, 쿠키의 저장을 거부할 경우 로그인이 필요한 모든 서비스를 이용할 수 없게 됨으로써 발생되는 문제에 대한 책임은 회원에게 있습니다. </p>
										</li>
										<li>
											<h4 class="agree_h2">제 17 조 (링크)</h4>
											<p class="agree_p">회사는 회원에게 다른 회사의 웹사이트 또는 자료에 대한 링크를 제공할 수 있습니다.<br/>
											회사는 그러한 사이트 및 자료에 대한 아무런 통제권이 없으므로, 회원은 회사가 그와 같은 외부 사이트나 자료의 유용성에 대해 책임이 없으며, 그러한 사이트나 자료에 대한, 또는 그로부터 이용 가능한 내용, 광고, 제품이나 재료에 대해 회사가 아무런 보증도 하지 않고, 그에 대해 책임이 없음을 인정하고 이에 동의합니다.<br/>
											또한, 회원은 그러한 사이트나 자료에 대한, 또는 그를 통하여 이용 가능한 내용, 상품 또는 서비스를 이용하거나 이를 신뢰함으로 인해, 또는 이와 관련하여 야기되거나 야기되었다고 주장되는 어떠한 손해나 손실에 대하여 회사가 직접적 또는 간접적으로 책임을 지지 않음을 인정하고 이에 동의합니다.</p>
										</li>
										<li>
											<h4 class="agree_h2">제 18 조 (이용요금)</h4>
											<ul class="agree_in">
												<li>① 회사는 개인계약/기업계약 여부에 따라 서비스를 선불형 또는 후불형으로 제공합니다.</li>
												<li>② 개인계약 이용시 무통장 입금, 계좌이체, 신용카드, 휴대폰결제 등으로 선불 결제 할 수 있으며, 기업계약 이용시 자동이체 설정 후 후불 결제 됩니다.</li>
												<li>③ 이용요금은 회사에서 정한 요금정책에 따라 적용되며, 회사가 별도 계약을 체결하는 경우 계약서에 명시된 요금을 적용합니다.</li>
												<li>④ 회사는 별도 정한 경우를 제외하고는 회원 개인 또는 사업자등록번호 단위로 이용요금을 부과합니다.</li>
											</ul>
										</li>
										<li>
											<h4 class="agree_h2">제 19 조 (청구 및 납입)</h4>
											<ul class="agree_in">
												<li>① 회사는 이용요금 납입청구서를 해당 청구월(1일~말일 거래분)의 익월 10일(영업일 기준)까지 인터넷을 통하여 회원에게 전송하고 회원은 사이트의 요금결제 메뉴를 이용하여 요금을 납부합니다.</li>
											</ul>
										</li>
										<li>
											<h4 class="agree_h2">제 20 조 (이용요금 반환)</h4>
											<ul class="agree_in">
												<li>① 회사는 이용요금 등의 과납이 있을 경우 회원의 이의신청(청구일로부터 3월 이내에 한함)에 따라 다음 각 호에 해당하는 조치를 취합니다. <br/>
													<ul class="agree_in02">
														<li>- 과납 청구한 이용요금 등에 대하여는 그 금액을 감액하여 신청일 익월에 이용요금에서 상계하거나 탈퇴한 회원의 경우 해당금액을 반환 처리합니다.</li>
														<li>- 이용요금 등을 반환 받아야 할 회원이 이용요금 등의 체납이 있는 경우 회사는 해당 금액에 대하여 공제하고 1호의 내용을 적용합니다.</li>
													</ul>
												</li>
												<li>② 회사는 과소청구액에 대하여는 익월에 합산하여 청구합니다.</li>
												<!-- 2018년 10월 18일 추가 -->
												<li>③ 회원의 환불 요청이 있을 경우 회사는 아래와 같이 환불 조치를 합니다.
													<div class="agree_in02">
														<p class="pd-0">- 환불 기준</p>
														<table class="term_tbl">
															<colgroup>
																<col style="width:40%"/>
																<col style="width:60%"/>
															</colgroup>
															<tr>
																<th class="ag_top">결제기간</th>
																<th class="ag_top">환불금액</th>
															</tr>
															<tr>
																<td>결제후 30일 이내</td>
																<td class="ag_left">결제후 30일 이내 결제금액의 10%차감 후 환불<br/>
																단, 잔액이 결제금액의 10%미만일 경우 환불 불가</td>
															</tr>
															<tr>
																<td>결제후 30일 이상 60일 이내</td>
																<td class="ag_left">결제금액의 20%차감 후 환불<br/>
																단, 잔액이 결제금액의 20%미만일 경우 환불 불가</td>
															</tr>
															<tr>
																<td>결제후 60일 이상 90일 이내</td>
																<td class="ag_left">결제금액의 30%차감 후 환불<br/>
																단, 잔액이 결제금액의 30%미만일 경우 환불 불가</td>
															</tr>
															<tr>
																<td>결제후 90일 이상 5년 이내</td>
																<td class="ag_left">환불 불가하며 잔액은 사용 가능</td>
															</tr>
														</table>
														<p class="mg_t5">- 결제후 5년이 지나면 잔액이 소멸되어 사용이 불가함.</p>
													</div>
												</li>
												<!-- //2018년 10월 18일 추가 -->
											</ul>
										</li>
									</ul>
									<h3 class="agree_h1">제 5 장 책임</h3>
									<ul class="agree_list">
										<li>
											<h4 class="agree_h2">제 21 조 (회사의 의무)</h4>
											<ul class="agree_in">
												<li>① 회사는 제7조 2항에서 정한 경우를 제외하고 이 약관 및 관계법령이 정한 바에 따라 계속적, 안정적으로 서비스를 제공할 의무가 있습니다.</li>
												<li>② 회사는 서비스 관련 설비를 항상 운용가능한 상태로 유지보수하며, 장애가 발생하거나 멸실된 경우 지체없이 이를 수리/복구할 수 있도록 최선의 노력을 다하여야 합니다.</li>
												<li>③ 회사는 회원으로부터 제기되는 의견이나 불만이 정당하다고 인정할 경우 신속히 처리하여야 합니다. 다만, 신속히 처리가 곤란한 경우 회원에게 그 사유와 처리일정을 E-mail이나 서면 또는 전화로 통지하여야 합니다.</li>
												<li>④ 회사는 이용계약의 체결, 계약사항의 변경 및 해지 등 회원과의 계약관련 절차 및 내용 등에 있어 회원에게 편의를 제공하도록 노력해야 합니다. </li>
											</ul>
										</li>
										<li>
											<h4 class="agree_h2">제 22 조 (회원의 의무)</h4>
											<ul class="agree_in">
												<li>① 회원은 이 약관 및 관계법령, 회사가 공지하는 사항을 준수하여야 하며, 기타 회사의 업무수행에 지장을 초래하는 행위를 할 수 없습니다.</li>
												<li>② 회원은 회사의 사전 승인 없이 서비스를 이용하여 어떠한 영리행위도 할 수 없습니다.</li>
												<li>③ 회원은 서비스를 이용하여 얻은 정보를 회사의 사전 승낙없이 복사, 복제, 개조, 번역하여 타인에게 제공하여서는 안됩니다.</li>
												<li>④ 회원은 자신의 ID와 비밀번호 / 블록체인 계정주소와 블록체인 비밀번호의 관리에 대하여 각별한 주의를 하여야 합니다.</li>
												<li>⑤ 회원은 자신의 ID가 부정하게 사용된 것을 발견한 즉시, 회사에 그 사실을 통보하여야 합니다.</li>
												<li>⑥ 회원은 서비스 이용과 관련하여 다음 각 호의 행위를 할 수 없습니다.<br/>
													<ul class="agree_in02">
														<li>- 다른 회원의 아이디(ID)를 부정 사용하는 행위.</li>
														<li>- 범죄행위를 목적으로 이용하거나 기타 범죄행위와 관련된 행위.</li>
														<li>- 선량한 풍속 기타 사회질서에 반하는 행위.</li>
														<li>- 타인의 명예를 훼손하거나 모욕하는 행위.</li>
														<li>- 타인의 지적재산권 등의 권리를 침해하는 행위.</li>
														<li>- 해킹 또는 컴퓨터바이러스를 유포하는 행위.</li>
														<li>- 광고 또는 광고성 정보를 전송 기타 영업을 위한 행위.</li>
														<li>- 서비스의 안정적인 운영에 지장을 주거나 줄 우려가 있는 일체의 행위.</li>
														<li>- 기타 관계법령에 위배되는 행위.</li>
														<li>- 회원 중 회사관리자의 자격을 부여 받은 회원은 기업의 블록체인 계정주소/블록체인 비밀번호 등의 보안, 유출방지의무가 있으며 이를 통한 본 사이트를 이용하는 회사 내 소속 회원에 대한 관리 책임을 부담하며 이에 따른 그 어떠한 문제에 대해서도 당사는 책임을 지지 않습니다. </li>
													</ul>
												</li>
											</ul>
										</li>
										<li>
											<h4 class="agree_h2">제 23 조 (서비스 이용의 제한)</h4>
											<ul class="agree_in">
												<li>① 회사는 회원이 이 약관 위반 및 다음 각 호에 해당하는 경우 회사가 정한 소정의 기간내에 이를 해소하지 않으면 서비스 이용계약을 사전 통지나 동의없이 이용 제한 할 수 있습니다.<br/>
													<ul class="agree_in02">
														<li>- 제21조의 규정에 의한 회원의 의무를 이행하지 아니한 경우</li>
														<li>- 회원이 서비스 이용요금을 납부기한 까지 납부하지 아니하는 경우</li>
														<li>- 회원이 해산으로 인하여 법인 자격을 상실하게 되거나 부 존재 한다고 볼 수 있는 상당한 이유가 있을 경우</li>
														<li>- 회원이 타인명의를 도용하여 신청 또는 신청서를 허위로 기재하는 등 부정한 방법으로 이용신청한 사실이 발견된 경우</li>
														<li>- 다른 회원 또는 제3자의 지적재산권을 침해하는 경우</li>
														<li>- 타인의 ID 또는 비밀번호를 부정하게 사용하는 경우</li>
														<li>- 서비스를 이용하여 얻은 정보를 회사의 사전 승낙없이 복제 또는 유통시키거나 상업적으로 이용하는 경우</li>
														<li>- 회원의 서비스 이용을 제한하거나 정지시킨 후 동일한 행위가 2회 이상 반복되는 경우</li>
														<li>- 사회통념상의 풍속, 사회질서를 해하는 행위 또는 타인의 명예를 손상시키거나 불이익을 주는 행위를 한 경우</li>
														<li>- 기타 이 약관이나 관계법령에서 정한 사항 위반 등 회원 자격을 그대로 유지시키기 어려운 상당한 이유가 있는 경우</li>
													</ul>
												</li>
												<li>② 회사는 이용제한할 경우 그 사유, 일시 및 기간을 정하여 이용제한 5일전까지 서면, 전화, e-mail 등을 통하여 회원에게 통지합니다.</li>
											</ul>
										</li>
										<li>
											<h4 class="agree_h2">제 24 조 (이용제한 해제)</h4>
											<p class="agree_p">회사는 이용제한기간중에 그 이용제한사유가 해소된 것이 확인된 경우 이용제한조치를 즉시 해제하며, 그 사실을 회원에게 통지합니다.</p>
										</li>
										<li>
											<h4 class="agree_h2">제 25 조 (서비스 제공의 제한 및 중지)</h4>
											<ul class="agree_in">
												<li>① 회사는 다음 각 호에 해당하는 경우 서비스의 이용을 전부 또는 일부를 제한하거나 중지할 수 있습니다.
													<ul class="agree_in02">
														<li>- 시스템 보수 및 데이터 관리를 위하여 부득이한 경우</li>
														<li>- 전기통신사업법에 규정된 기간통신사업자가 전기통신서비스를 중지한 경우</li>
														<li>- 국가 비상사태, 천재지변이 발생하거나 발생할 우려가 있는 경우</li>
													</ul>
												</li>
												<li>② 제①항에 의한 서비스 중단의 경우 그 사유 등을 홈페이지에 게시하거나 회원에게 통지합니다. 다만 회사가 통제할 수 없는 사유로 인하여 사전통지가 불가능한 경우 그러하지 아니합니다. </li>
											</ul>
										</li>
										<li>
											<h4 class="agree_h2">제 26 조 (해지)</h4>
											<ul class="agree_in">
												<li>① 회원이 이용계약을 해지하고자 하는 경우 신청서에 의거 전화, 팩스 또는 E-Mail 을 통하여 회사에 신청하여야 합니다.</li>
												<li>② E-Mail 을 통하여 회원탈퇴를 신청한 경우에는 본인을 확인할 수 있는 이름, 아이디(ID), 비밀번호, 연락처 및 해지사유를 통보하여야 하며, 이 경우 당사는 회원등록정보와 대조하여 본인 여부를 확인한 후 해지하여야 합니다.</li>
												<li>③ 이용계약의 해지시 회원은 최종 요금 납부 이후 이용한 서비스에 대한 이용요금을 모두 납입하여야 합니다.</li>
												<li>④ 회사는 회원이 제21조 및 기타 이 약관의 규정을 위반하고, 당사가 정한 소정의 기간 내에 이를 해소하지 아니하는 경우에 서비스 이용계약을 사전 통지나 동의 없이 해지할 수 있습니다.</li>
											</ul>
										</li>
									</ul>
									<h3 class="agree_h1">제 6 장 기타</h3>
									<ul class="agree_list">
										<li>
											<h4 class="agree_h2">제 27 조 (양도금지)</h4>
											<p class="agree_p">회원이 서비스의 이용권한, 기타 이용계약상 지위를 타인에게 양도하거나 담보로 제공할 수 없습니다.</p>
										</li>
										<li>
											<h4 class="agree_h2">제 28 조 (손해배상)</h4>
											<ul class="agree_in">
												<li>① 회원이 제21조 및 기타 이 약관의 규정을 위반함으로 인하여 회사가 다른 회원 또는 제3자에 대하여 책임을 부담하게 되고 이로 인해 회사가 손해를 입게 되는 경우 회원은 회사에게 모든 손해를 배상하여야 합니다.</li>
												<li>② 회사는 서비스 제공과 관련하여 회원에게 어떠한 손해가 발생한 경우 고의 또는 중과실이 없는 한 이에 대하여 책임지지 않습니다.</li>
											</ul>
										</li>
										<li>
											<h4 class="agree_h2">제 29 조 (면책사항)</h4>
											<ul class="agree_in">
												<li>① 회사는 회원이 게재한 정보, 자료 및 그에 대한 사실의 정확성, 신뢰성 등에 관하여는 어떠한 책임도지지 않으며, 서비스를 이용하여 게시 또는 전송한 자료, 자료의 취사선택, 기타 서비스 이용과 관련하여 회원에게 어떠한 손해 또는 불이익이 발생하더라도 이에 대한 모든 책임은 회원에게 있습니다.</li>
												<li>② 회사는 제21조 규정을 위반하여 회원간 또는 회원과 제3자간에 회사의 서비스를 매개로 하여 물품거래 등의 행위에 대하여 어떠한 책임도 지지 않습니다.</li>
												<li>③ 회원 아이디(ID)와 비밀번호/ 블록체인 계정주소와 블록체인 비밀번호의 관리 및 이용상의 부주의로 인하여 발생되는 손해 또는 제3자에 의한 부정사용 등에 대한 책임은 모두 회원에게 있습니다.</li>
												<li>④ 회사는 다음 각호의 경우에 대하여는 책임을 지지 아니합니다.<br/>
													<ul class="agree_in02">
														<li>- 천재지변 등 불가항력적인 사유로 서비스를 제공하지 못하는 경우</li>
														<li>- 회원이 제공하는 자료의 오류로 인하여 발생한 손해</li>
														<li>- 통신기기, 통신회선 또는 회사의 전산 시스템 장애에 의한 업무처리의 지연이나 불능일 경우</li>
														<li>- 회원이 바이러스 침투, 불법S/W설치 등 관리소홀 및 부주의로 손해가 발생한 경우</li>
														<li>- 기타 회사의 과실로 인하여 발생한 사고가 아닌 경우</li>
													</ul>
												</li>
											</ul>
										</li>
										<li>
											<h4 class="agree_h2">제 30 조 (분쟁해결 및 관할법원)</h4>
											<ul class="agree_in">
												<li>① 본 계약의 해석과 관련하여 이견이 있을 경우 및 본 계약에 제시되지 않은 사항이 있을 경우 관련법규가 있으면 그 관련법규를 따르고 관련법규가 없으면 신의성실의 원칙에 입각, 상호협의하여 결정합니다.</li>
												<li>② 본 계약과 관련한 분쟁의 해결에 대해서는 서울지방법원을 관할법원으로 합니다.</li>
											</ul>
										</li>
										<li>
											<h4 class="agree_h2">제 31 조 (면책조항)</h4>
											<ul class="agree_in">
												<li>①계약 작성자는 계약 수신자 정보(이름, 휴대폰 번호, 메일 주소 등)의 진위 여부를 확인한 후 계약을 발송해야하며, 잘못된 정보 입력으로 발생하는 문제에 대해 책임지지 않습니다.</li>
												<li>②글로싸인엔터프라이즈를 통해 이뤄지는 회원 및 이용자 간에 이뤄지는 전자계약 작성, 전송, 서명 등 진행과정과 내용 이행 등에서 발생하는 분쟁에 대해 책임지지 않습니다.</li>
											</ul>
										</li>
										<li>
											<ul class="agree_in">
												<li>공고일자 : 2022년 10월 5일</li>
												<li>시행일자 : 2022년 10월 12일</li>
											</ul>
										</li>
									</ul>
								</v-col>
								<!--/시행중인 이용약관 보기-->
							</v-row>
						</div>
					</div>
				</div>
				<div class="mt-4">
					<div class="dot_tt16 mb-2">개인정보처리방침</div>
					<div class="signU_rule_box H02">
						<div class="ruleboxst">
							<v-row no-gutters>
								<v-col cols="12" class="protPage">
								<div class="prot_box">
									<ul class="agree_list">
										<li>글로싸인엔터프라이즈는 정보주체의 개인정보 보호를 위해 「개인정보 보호법」 및 관계 법령이 정한 바를 준수하여, 적법하게 개인정보를 처리하고 안전하게 관리하고 있습니다. </li>
										<li>개인정보처리방침은 정부의 법률 및 지침의 변경과 글로싸인엔터프라이즈의 정책 변화에 따라 변경될 수 있고, 이에 따라 개인정보처리방침을 개정하는 경우 공지사항을 통하여 미리 공지하여 고객이 확인할 수 있도록 조치하고 있습니다.</li>
										<li>글로싸인엔터프라이즈는 개인정보취급방침을 통하여 고객들이 제공하는 개인정보가 어떠한 용도와 방식으로 이용되고 있으며 개인정보보호를 위해 어떠한 조치가 취해지고 있는지 알려드리고자 합니다.</li>
									</ul>
								</div>
								<h3 class="agree_h1">글로싸인엔터프라이즈 개인정보취급방침은 다음과 같은 내용을 담고 있습니다.</h3>
								<ul class="agree_list">
									<li>
									<ul class="agree_in">
										<li>1. 개인정보의 처리목적</li>
										<li>2. 처리하는 개인정보 항목</li>
										<li>3. 개인정보의 처리 및 보유기간</li>
										<li>4. 개인정보의 제3자 제공</li>
										<li>5. 개인정보처리의 위탁</li>
										<li>6. 개인정보의 파기</li>
										<li>7. 정보주체와 법정대리인의 권리·의무 및 행사방법</li>
										<li>8. 개인정보의 안정성 확보 조치</li>
										<li>9. 개인정보 자동수집 장치의 설치, 운영 및 그 거부에 관한 사항</li>
										<li>10. 개인정보 보호책임자에 관한 사항</li>
										<li>11. 개인정보의 열람청구를 접수·처리하는 부서</li>
										<li>12. 정보주체의 권익침해에 대한 구제방법</li>
										<li>13. 개인정보 처리방침의 변경에 관한 사항</li>
									</ul>
									</li>
								</ul>
								<ul class="agree_list">
									<li>
									<h4 class="agree_h2">1. 개인정보의 처리목적</h4>
									<ul class="agree_in">
										<li>회사는 아래의 목적을 위해 개인정보를 처리합니다. 처리하고 있는 개인정보는 아래의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.</li>
										<li><span class="prot_txtb">가. 서비스 제공에 관한 계약 이행 및 서비스 제공에 따른 요금정산</span><br/>
										<ul class="pt_mgl">
											<li>전자계약 서비스 이용시 필요한 정보전달 및 요금결제, 청구서 발송</li>
										</ul>
										</li>
										<li><span class="prot_txtb">나. 회원 관리</span><br/>
										<ul class="pt_mgl">
											<li>회원제 서비스 이용 및 제한적 본인 확인제에 따른 본인확인, 개인 식별, 신용평가기관을 통한 실명확인, 연령제한 서비스의 제공, 부정이용방지와 비인가 사용 방지, 가입 의사 확인, 불만처리 등 민원처리, 고지사항 전달</li>
										</ul>
										</li>
										<li><span class="prot_txtb">다.	마케팅 및 광고 활용</span><br/>
										<ul class="pt_mgl">
											<li>마케팅 및 광고 활용, 회원의 서비스 이용에 대한 통계, 통계학적 분석(회원의 업종별, 기업규모별, 지역별 통계분석 등</li>
										</ul>
										</li>
									</ul>
									</li>
									<li>
									<h4 class="agree_h2">2. 처리하는 개인정보 항목</h4>
									<ul class="agree_in">
										<li>회사는 회원가입, 원활한 고객상담, 각종 서비스의 제공 등을 위해 필요한 최소한의 개인정보를 수집하고 있습니다.</li>
										<!-- 가. -->
										<li><span class="prot_txtb">가.	수집하는 개인정보의 항목</span><br/>
										<ul class="pt_mgl">
											<li>1) 수집하는 개인정보 유형 및 항목</li>
											<li>
												<table class="term_tbl">
													<colgroup>
													<col style="width:20%"/>
													<col style="width:10%"/>
													</colgroup>
													<tr>
													<td>회원가입</td>
													<td>필수</td>
													<td>아이디, 비밀번호, 이름, 연락처, 주소, 상세주소, 이메일, 블록체인 비밀번호</td>
													</tr>
													<tr>
													<td rowspan="2">유료 서비스 이용 관련 결제</td>
													<td>필수</td>
													<td>[신용카드] 카드사, 카드번호, CVC번호, 유효기간, 이름, 생년월일, 성별, 휴대전화번호, 주민등록번호(앞7자리), 결제비밀번호<br/>
														[계좌이체] 예금주명, 주민/사업자번호, 금융기관, 계좌번호, 계좌비밀번호, 계좌구분, 주민번호(앞7자리), 사업자등록번호, 휴대폰번호, 생년월일(6자리), PIN<br/>
														[무통장입금] 예금주명, 은행명, 입금자명<br/>
														[휴대폰결제] 예금주명, 이동통신사, 휴대폰번호, 주민번호(앞7자리)
													</td>
													</tr>
													<tr>
													<td>선택</td>
													<td>[신용카드] 이메일<br/>
														[계좌이체] 이메일<br/>
														[무통장입금] 휴대폰번호, 이메일<br/>
														[휴대폰결제] 이메일
													</td>
													</tr>
													<tr>
													<td rowspan="2">도입문의</td>
													<td>필수</td>
													<td>회사명, 이메일, 연락처, 문의내용</td>
													</tr>
													<tr>
													<td>선택</td>
													<td>월 평균 계약건수</td>
													</tr>
												</table>
											</li>
											<li>2) 서비스 이용과정에서 아래와 같은 정보들이 자동 생성 및 수집</li>
											<li>- IP Address, 쿠키, 방문 일시, 서비스 이용 기록, 불량 이용 기록</li>
										</ul>
										</li>
										<!-- 가. 끝 -->
										<li><span class="prot_txtb">나.	개인정보 수집방법</span><br/>
										<ul class="pt_mgl">
											<li>회사는 아래와 같은 방법으로 개인정보를 수집합니다.</li>
											<li>- 홈페이지 회원가입, 도입 문의 및 고객 응대 과정에서 수집, 서비스 이용 또는 처리과정에서 자동 혹은 수동으로 생성되어 수집</li>
										</ul>
										</li>
									</ul>
									</li>
									<li>
									<h4 class="agree_h2">3. 개인정보의 처리 및 보유기간</h4>
									<ul class="agree_in">
										<li>회사는 아래의 정보에 대하여 관계 법령에서 명시한 기간 동안 개인정보를 보유합니다. 
											법령에 따른 개인정보 보유 및 이용기간 또는 정보주체로부터 개인정보를 수집 시에 동의 받은 개인정보 보유 및 이용기간 내에서 개인정보를 처리 보유합니다 <br/>
										<ul class="ag_mgl">
											<li>가.	본인확인에 관한 기록 <br/>
											- 보존 근거 : 정보통신망 이용촉진 및 정보보호 등에 관한 법률 <br/>
											- 보존 기간 : 6개월</li>
											<li>나.	계약 또는 청약철회 등에 관한 기록 <br/>
											- 보존 이유 : 전자상거래 등에서의 소비자보호에 관한 법률 <br/>
											- 보존 기간 : 5년 </li>
											<li>다.	대금결제 및 재화 등의 공급에 관한 기록 <br/>
											- 보존 이유 : 전자상거래 등에서의 소비자보호에 관한 법률 <br/>
											- 보존 기간 : 5년</li>
											<li>라.	소비자의 불만 또는 분쟁처리에 관한 기록 <br/>
											- 보존 이유 : 전자상거래 등에서의 소비자보호에 관한 법률 <br/>
											- 보존 기간 : 3년<br/></li>
											<li>마.	표시 광고에 관한 기록 <br/>
											- 보존 이유 : 전자상거래 등에서의 소비자보호에 관한 법률 <br/>
											- 보존 기간 : 6개월<br/></li>
											<li>바.	웹사이트 방문에 관한 기록 <br/>
											- 보존 이유 : 통신비밀보호법 <br/>
											- 보존 기간 : 3개월<br/></li>
											<li>사.	보유기간을 정보주체에게 미리 고지하고 그 보유기간이 경과하지 아니한 경우와 개별적으로 정보주체의 동의를 받을 경우에는 약속한 기간 동안 보유 </li>
										</ul>
										</li>
									</ul>
									</li>
									<li>
									<h4 class="agree_h2">4. 개인정보의 제3자 제공</h4>
									<ul class="agree_in">
										<li>회사는 정보주체의 개인정보를 '1. 개인정보의 처리목적'에서 고지한 범위 내에서 개인정보를 이용하며, 동 범위를 초과하여 이용하거나 타인 또는 타 기관에 제공 또는 공유하지 않습니다.</li>
										<li>다만, 아래의 경우에는 예외적으로 정보주체의 동의 없이 개인정보를 제공할 수 있습니다.<br/>
										<ul class="ag_mgl">
											<li>가.	법령의 규정에 의거하거나, 수사상 목적으로 법령에 정해진 절차와 방법에 따라 관련기관의 요구가 있는 경우</li>
											<li>나.	정보주체가 사전에 동의한 경우</li>
											<li>다.	유료 서비스 제공에 따른 요금 결제를 위하여 필요한 경우</li>
											<li>라.	신용평가기관을 통한 본인확인에 필요한 경우</li>
											<li>마.	통계처리, 학술연구, 시장조사 등을 위하여 필요한 경우에는 특정한 개인을 식별할 수 없는 형태로 가공하여 제공하는 경우</li>
											<li>바.	기타 관계법령에서 정한 절차에 따른 요청이 있는 경우</li>
										</ul>
										</li>
									</ul>
									</li>
									<li>
									<h4 class="agree_h2">5. 개인정보처리의 위탁</h4>
									<ul class="agree_in">
										<li>① 회사는 원활한 개인정보 업무처리를 위하여 아래와 같이 개인정보 처리업무를 위탁하고 있습니다.</li>
										<li>
										<table class="term_tbl">
											<colgroup>
											<col style="width:30%"/>
											<col style="width:30%"/>
											<col style="width:40%"/>
											</colgroup>
											<tr>
											<th scope="col">수탁업체</th>
											<th scope="col">위탁업무 내용</th>
											<th scope="col">보유 및 이용기간</th>
											</tr>
											<tr>
											<td>코리아크레딧뷰로㈜</td>
											<td>본인인증 서비스</td>
											<td rowspan="5">회원 탈퇴 시 혹은 위탁 계약 종료시까지</td>
											</tr>
											<tr>
											<td>토스페이먼츠</td>
											<td>서비스 이용요금 결제 대행</td>
											</tr>
											<tr>
											<td>세종텔레콤</td>
											<td>문자 메시지 서비스</td>
											</tr>
											<tr>
											<td>비즈톡</td>
											<td>카카오톡 메시지 서비스</td>
											</tr>
											<tr>
											<td>시스원</td>
											<td>서비스 인프라 유지보수</td>
											</tr>
										</table>
										</li>
										<li>② 회사는 위탁계약 체결 시 「개인정보 보호법」 제26조에 따라 위탁업무 수행목적 외 개인정보 처리금지, 기술적·관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리·감독, 손해배상 등 책임에 관한 사항을 계약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.</li>
										<li>③ 위탁업무의 내용이나 수탁자가 변경될 경우에는 지체없이 본 개인정보 처리방침을 통하여 공개하도록 하겠습니다.</li>
									</ul>
									</li>
									<li>
									<h4 class="agree_h2">6. 개인정보의 파기</h4>
									<ul class="agree_in">
										<li>회사는 원칙적으로 개인정보의 처리목적이 달성되면 지체 없이 파기합니다. 파기절차 및 방법은 다음과 같습니다.</li>
										<li><span class="prot_txtb">가. 파기절차</span><br/>
										<ul class="pt_mgl">
											<li>정보주체가 서비스 이용 등을 위해 입력한 정보는 목적이 달성된 후 별도의 DB로 옮겨져 개인정보의 보유 및 이용기간에 따라 일정 기간 저장된 후 파기됩니다. <br/>
												별도 DB로 옮겨진 개인정보는 법률에 의한 경우가 아니고서는 보유되어지는 이외의 다른 목적으로 이용되거나 제공되지 않습니다. </li>
										</ul>
										</li>
										<li><span class="prot_txtb">나. 파기방법</span><br/>
										<ul class="pt_mgl">
											<li>- 전자적 파일형태로 기록·저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.</li>
											<li>- 종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.</li>
										</ul>
										</li>
									</ul>
									</li>
									<li>
									<h4 class="agree_h2">7. 정보주체와 법정대리인의 권리·의무 및 행사방법</h4>
									<ul class="agree_in">
										<li>① 정보주체는 언제든지 개인정보 열람·정정·삭제·처리정지 요구 등의 권리를 행사할 수 있습니다. 다만, 서비스 제공을 위해 반드시 필요한 개인정보를 삭제하는 경우 서비스의 일부 또는 전부 이용이 어려울 수 있습니다.</li>
										<li>② 권리 행사는 서면, 전자우편, 모사전송(FAX) 등을 통하여 하실 수 있으며 이에 대해 지체없이 조치하겠습니다.</li>
										<li>③ 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수 있습니다. 이 경우 “개인정보 처리 방법에 관한 고시(제2023-12호)” 별지 제11호 서식에 따른 위임장을 제출하셔야 합니다.</li>
										<li>④ 개인정보 열람 및 처리정지 요구는 「개인정보 보호법」 제35조 제4항, 제37조 제2항에 의하여 정보주체의 권리가 제한될 수 있습니다.  </li>
										<li>⑤ 개인정보의 정정 및 삭제 요구는 다른 법령에서 그 개인정보가 수집 대상으로 명시되어 있는 경우에는 그 삭제를 요구할 수 없습니다. </li>
										<li>⑥ 회사는 정보주체 권리에 따른 열람의 요구, 정정·삭제의 요구, 처리정지의 요구 시 열람 등 요구를 한 자가 본인이거나 정당한 대리인인지를 확인합니다. </li>
									</ul>
									</li>
									<li>
									<h4 class="agree_h2">8. 개인정보의 안정성 확보 조치</h4>
									<ul class="agree_in">
										<li>① 회사는 이용자의 개인정보를 처리함에 있어 개인정보가 분실, 도난, 누출, 변조 또는 훼손되지 않도록 안정성 확보를 위해 아래와 같은 조치를 취하고 있습니다.</li>
										<li><span class="prot_txtb">가.	관리적 조치</span><br/>
										<ul class="pt_mgl">
											<li>1)	‘개인정보의 안전성 확보조치 기준'에 따라 내부관리계획을 수립 및 시행합니다.</li>
											<li>2)	개인정보취급자의 지정을 최소화하고 개인정보보호 교육을 시행하고 있습니다.</li>
										</ul>
										</li>
										<li><span class="prot_txtb">나.	기술적 조치</span><br/>
										<ul class="pt_mgl">
											<li>1)	침입차단시스템과 탐지시스템을 이용하여 외부로부터의 무단접근을 통제하고 있습니다. 또한 개인정보처리시스템에 대한 접근권한 관리를 통하여 개인정보에 대한 접근을 통제하며, 권한 부여, 변경 또는 말소에 대한 내역을 기록하고, 그 기록을 최소 3년간 보관하고 있습니다.</li>
											<li>2)	이용자의 개인정보를 암호화된 통신구간(SSL)을 이용하여 전송하고, 비밀번호 등 중요정보는 안전한 암호화 알고리즘으로 암호화되어 저장/관리되고 있습니다.</li>
											<li>3)	개인정보처리시스템에 접속한 기록을 최소 2년 이상 보관, 관리하고 있으며, 접속 기록이 위변조 및 도난, 분실되지 않도록 관리하고 있습니다.</li>
											<li>4)	해킹이나 컴퓨터 바이러스 등에 의한 개인정보 유출 및 훼손을 막기 위해 보안프로그램을 설치하고 주기적인 갱신·점검을 하며 외부로부터 접근이 통제된 구역에 시스템을 설치하고 기술적, 물리적으로 감시 및 차단하고 있습니다.</li>
										</ul>
										</li>
										<li><span class="prot_txtb">다.	물리적 조치</span><br/>
										<ul class="pt_mgl">
											<li>1)	개인정보를 보관하고 있는 개인정보처리시스템의 물리적 보관 장소를 별도로 두고 이에 대해 출입통제 절차를 수립, 운영하고 있습니다.</li>
											<li>2)	개인정보가 포함된 서류, 보조저장매체 등을 잠금장치가 있는 안전한 장소에 보관하고 있습니다.</li>
										</ul>
										</li>
										<li>② 이용자의 부주의나 회사가 관리하지 않는 영역에서의 사고 등 회사의 귀책에 기인하지 않은 손해에 대해서 회사는 책임을 지지 않습니다.</li>
										<li>③ 이용자의 아이디와 비밀번호는 반드시 본인만 사용하시고, 영문자, 숫자, 특수문자를 조합하여 타인이 유추하기 어려운 비밀번호를 사용하는 것이 좋습니다.</li>
										<li>④ 서비스의 이용을 마친 후에는 항상 로그아웃 하여 웹 브라우저를 종료하는 것이 좋습니다. 특히, 다른 사람과 컴퓨터를 공유하거나, 공공장소에서 이용하는 경우에 개인정보보호를 위해서는 이와 같은 절차가 더욱 필요합니다.</li>
									</ul>
									</li>
									<li>
									<h4 class="agree_h2">9. 개인정보 자동수집 장치의 설치, 운영 및 그 거부에 관한 사항</h4>
									<ul class="agree_in">
										<li>회사는 이용자의 정보를 수시로 저장하고 찾아내는 '쿠키(cookie)'를 개인정보를 자동으로 수집하는 장치로 설치. 운용합니다.  <br/>
											쿠키란 웹사이트를 운영하는데 이용되는 서버가 이용자의 브라우저에 보내는 아주 작은 텍스트 파일로서 이용자의 컴퓨터 하드디스크에 저장됩니다.</li>
										<li>회사는 아래와 같은 목적을 위해 쿠키 등을 사용합니다.</li>
										<li>가.	쿠키 등 사용 목적<br/>
										- 이용자를 인식하여 화면 이동시 사용의 편리성 제공 및 이용자에게 최적화된 정보 제공<br/>
										귀하는 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서, 고객은 웹브라우저에서 옵션을 설정함으로써 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 아니면 모든 쿠키의 저장을 거부할 수도 있습니다.</li>
										<li>나.	쿠키 설정 거부 방법<br/>
										이용자는 웹 브라우저의 옵션을 설정함으로써 모든 쿠키를 허용하거나 쿠키를 저장할 때마다 확인을 거치거나, 모든 쿠키의 저장을 거부할 수 있습니다. <br/>
										단, 쿠키 설치를 거부하였을 경우 서비스 제공에 어려움이 있을 수 있습니다. <br/>
										- 설정방법 <br/>
										1)	Internet Explorer의 경우: 웹 브라우저 상단의 도구 메뉴 > 인터넷 옵션 > 개인정보 > 설정 <br/>
										2)	Chrome의 경우: 웹 브라우저 우측의 설정 메뉴 > 화면 하단의 설정 표시 > 개인정보 보호 및 보안 > 서드 파티 쿠키 <br/>
										3)	마이크로소프트 엣지의 경우 :  웹 브라우저 상단의 [ ··· ] 클릭 > 설정 > 쿠키 및 사이트 권한 > 쿠키 및 사이트 데이터 관리 및 삭제 > 쿠키 차단여부 선택 <br/>
										4)	모바일 사파리의 경우 : 설정 > 사파리 > 쿠키 차단여부 선택 <br/>
										단, 고객께서 쿠키 설치를 거부하였을 경우 서비스 제공에 어려움이 있을 수 있습니다.</li>
									</ul>
									</li>
									<li>
									<h4 class="agree_h2">10. 개인정보 보호책임자에 관한 사항</h4>
									<ul class="agree_in">
										<li>회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만처리 및 피해구제 등을 위하여 아래와 같이 개인정보보호책임자를 지정하고 있습니다.</li>
										<li>가. 개인정보 보호책임자<br/>
											- 성명 : 곽상훈<br/>
											- 소속 : 스마트빌사업본부 솔루션서비스팀<br/>
										</li>
										<li>나. 개인정보 보호담당자<br/>
											- 성명 : 이상혁<br />
											- 소속 : 연구소<br />
											- E-mail : privacy@businesson.co.kr<br />
										</li>
										<li>다. 개인정보 관련 고충처리<br/>
											- 고객서비스팀<br />
											- 전화번호 : 1588-8064<br />
											- 팩스번호 : 02-559-0808<br />
										</li>
									</ul>
									</li>
									<li>
									<h4 class="agree_h2">11. 개인정보의 열람청구를 접수·처리하는 부서</h4>
									<ul class="agree_in">
										<li>회사는 개인정보의 열람청구와 관련하여 원활한 의사소통을 위해 아래의 부서를 운영하고 있습니다. </li>
										<li>가. 개인정보 열람청구 접수·처리 부서 <br/>
											- 고객서비스팀<br />
											- 전화번호 : 1588-8064<br />
											- 팩스번호 : 02-559-0808<br />
										</li>
									</ul>
									</li>
									<li>
									<h4 class="agree_h2">12. 정보주체의 권익침해에 대한 구제방법</h4>
									<ul class="agree_in">
										<li>개인정보침해로 인한 구제를 받기 위하여 개인정보분쟁조정위원회, 한국인터넷진흥원 개인정보침해신고센터 등에 분쟁해결이나 상담 등을 신청할 수 있습니다.</li>
										<li>- 개인정보분쟁조정위원회 : (국번없이 1833-6972 / www.kopico.go.kr)</li>
										<li>- 개인정보침해신고센터 : (국번없이 118 / privacy.kisa.or.kr)</li>
										<li>- 대검찰청 : (국번없이 1301 / www.spo.go.kr)</li>
										<li>- 경찰청 : (국번없이 182 / ecrm.cyber.go.kr)</li>
									</ul>
									</li>
									<li>
									<h4 class="agree_h2">13. 개인정보 처리방침의 변경에 관한 사항</h4>
									<ul class="agree_in">
										<li>개인정보처리방침 내용 추가, 삭제 및 수정이 있을 시에는 홈페이지의 '공지사항'을 통해 고지합니다. </li>
										<li>시행일자 : 2024년 04월 15일</li>
									</ul>
									</li>
								</ul>
								</v-col>
							</v-row>
						</div>
					</div>
				</div>
			</v-card-text>
			<!--팝업 버튼-->
			<v-card-actions class="justify-center">
			<v-btn text @click="dialogAgree = false">닫기</v-btn>
			</v-card-actions>
			<!--/팝업 버튼-->
		</v-card>
	</v-dialog>
	<!--/(팝업)이용약관 및 개인정보처리방침-->

	<!--(팝업)간편 회원 전환-->
	<v-dialog title="간편 회원 전환" v-model="dialogPass" width="472" append-to-body>
		<v-card id="popStyle03">
			<v-card-text class="signup-text_in_Con pt-6">
				<div class="dot_tt16 mb-2">글로싸인엔터프라이즈 회원 간편 전환 처리에 대한 내용</div>
				<v-row no-gutters class="popWgeust_txt">
					글로싸인엔터프라이즈는 블록체인 기술을 이용한 전자 계약 서비스입니다. 데이터 위변조가 불가능한 블록체인 네트워크에 전자계약 정보를 전송하기 위해서는 글로싸인엔터프라이즈 회원 정보에 추가로 회원의 블록체인 인증 비밀번호 (2차 인증)을 입력받게 되어있습니다.<br><br>
					비회원으로 계약을 수신받은 이용자가 현재 회원 간편 전환 화면을 이용하여 회원 가입을 진행하신 경우에는 블록체인 인증 비밀번호를 글로싸인엔터프라이즈 로그인 비밀번호로 같이 설정하여 드립니다. 추후 개인 정보 보안 강화를 위해 글로싸인엔터프라이즈에 회원 로그인을 진행하신 후 [설정] -> [블록체인 관리] -> [비밀번호 변경]을 이용하여 블록체인 인증 비밀번호를 변경하시기 바랍니다.<br><br>
					회원 간편 전환 후 비회원으로 수신받은 과거 전자계약은 글로싸인엔터프라이즈에 접속하여 회원 로그인 후 확인하실 수 있습니다.<br><br>
				</v-row>
			</v-card-text>
			<!--팝업 버튼-->
			<v-card-actions class="justify-center">
			<v-btn text @click="dialogPass = false">닫기</v-btn>
			</v-card-actions>
			<!--/팝업 버튼-->
		</v-card>
	</v-dialog>
	<!--/(팝업)간편 회원 전환-->

	<!--<v-dialog title="인증메일 발송 안내" v-model="dialogVisible" width="472" append-to-body id="popStyle02">-->
      <v-card id="popStyle02" class="popWgeust" v-if="!changeMemdialog">
        <!--<v-btn fab class="popBtnClose"></v-btn>-->
        <v-card-text>
          <v-row no-gutters class="justify-center row_mb-20">글로싸인엔터프라이즈 회원가입을 위해 인증메일을 확인바랍니다.</v-row>
          <v-row no-gutters class="justify-center row_mb-20">
						<v-col>
						<span class="fc_C03">[{{ accountform.email }}]</span>
						<span class="txtst_info_gray">으로 전송된 가입인증메일 링크 클릭 후 글로싸인엔터프라이즈에서 수신된 계약서를 확인하세요.</span>
						</v-col>
					</v-row>
        </v-card-text>
        <!--팝업 버튼-->
        <v-card-actions class="justify-center">
          <v-btn outlined class="btn19_00 btnC_01 btn_bottom_W314" @click="login">글로싸인엔터프라이즈로 이동합니다.</v-btn>
        </v-card-actions>
        <!--/팝업 버튼-->
      </v-card>
		<s-confirm ref="confirm"></s-confirm>
		<s-loading ref="loading"></s-loading>
</v-container>
</template>
<script>
import sha256 from 'sha256'
import { isValid, changeMember, checkAuthMail } from '@/api/join'

export default {
	name: 'registerUser',
	props:{
		contractNumber: String,
		contractSeq: String,
    email : String,
	},
	compenonts: {
    sha256
  },
  data () {
    return {
			rules: {
				useridRules: [
					v => !!v || '아이디를 입력해 주세요',
					v => /^[a-zA-Z0-9]{6,12}$/.test(v) || '영어, 숫자 포함하여 6~12자리로 입력해 주십시요'
				],
				passwordRules: [
					v => !!v || '비밀번호를 입력해 주세요',
					v => /^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]{6,12}$/.test(v) || '영어, 숫자 포함하여 6~12자리로 입력해 주십시요'
				],
				passwordreRules: [
					v => !!v || '비밀번호를 입력해 주세요',
					v => this.accountform.password === this.accountform.passwordre || '비밀번호가 일치하지않습니다'
				],
				nameRules: [
					v => !!v || '이름을 입력해 주세요',
					v => /^[가-힣|a-z|A-Z]{2,16}$/.test(v) || '한글 또는 영문만 2~16자리로 입력해 주십시요'
				],
				phoneRules: [
					v => !!v || '연락처를 입력해주세요',
					v => (/^(01[016789]{1})([0-9]{7,8})$/.test(v) && v.length !==0 ) || '연락처를 정확히 입력해주세요'
				],
				addrMainRules: [
						v => !!v || '주소지를 입력해주세요'
				],
				addrSubRules: [
						v => !!v || '주소지 (상세)를 입력해주세요'
				],
			},
			changeMemdialog: true,
			dialogVisible: false,
			valid: true,
			isAlreadyUse: false,
			dialogAgree: false,
			dialogPass: false,
			isCheckId: '',
      accountform: {
				auth_key: '',
        email: '',
        radio_trem_paivacy_op1: false,
        radio_trem_paivacy_op2: false,
        userid: '',
        password: '',
        password_re: '',
        name: '',
        addr_main: '',
        addr_sub: '',
        phone: '',
        term_use: '',
        term_paivacy_op1: '',
        term_paivacy_op2: '',
				term_use_sw: '',
				usr_join_path: '',
			},
			term_info: {
        TERM_CTR_MAIL: false,
        TERM_MAIL: false
      },
      swId: ''
    }
  },
  created () {
		if (this.$store.state.user.username !== '') {
			this.$refs.confirm.open('confirm', '회원가입', '로그인 사용자입니다. 로그아웃 후 이용하세요').then(() => {
				this.$router.push('/')
			})
		}
	},
	mounted () {
		this.accountform.email = this.email
		this.accountform.ctrNo = this.contractNumber
	},
  methods: {
		isValidID () {
      if (this.accountform.userid === '') {
				this.$refs.confirm.open('alert', '회원가입', '아이디(ID)를 입력하세요')
			} else if(this.accountform.userid.length < 6 || this.accountform.userid.length > 12) {
				this.$refs.confirm.open('alert', '회원가입', '아이디(ID)를 확인해주세요')
			} else {
        this.isAlreadyUse = false
        this.isCheckId = ''
        isValid(JSON.stringify({ userID: this.accountform.userid })).then(Response => {
          if (Response.rdata.isValid) {
            this.isCheckId = this.accountform.userid
          }else{
						this.isAlreadyUse = true
					}
        })
      }
		},
		submitForm (formName) {
			if(this.isCheckId === this.accountform.userid) {
				var validate = this.$refs.accountform.validate()
				if (validate) {
					if(this.accountform.term_use && this.accountform.term_use_sw) {
						this.$refs.loading.start('입력 정보 확인 중')
						if(this.contractNumber !== null && this.contractNumber !== undefined) {
							this.accountform.usr_join_path = '/v2/contractLock?contNo=' + this.contractNumber + '&contSeq=' +this.contractSeq
						} else {
							this.accountform.usr_join_path = '/v2/service/common/V2JoinService.java'
						}

						this.$nextTick(() => {
							changeMember(JSON.stringify({ user: this.accountform })).then(Response => {
								this.changeMemdialog = false
								if (Response.rdata !== undefined && Response.rdata.rcode === 20000) {
									this.isRegister = 1
									this.$refs.loading.end()
									this.dialogVisible = true
                  this.swId = Response.rdata.user.swId
								} else {
									this.$refs.loading.end()
									var msg = ''
									if (Response.rdata === undefined) {
										msg = Response.message
									} else {
										msg = Response.rdata.message
									}
									this.$refs.confirm.open('confirm', '회원가입', msg).then(() => {
										this.$router.push({ name: 'main' })
									})
								}
							})
						})
					}else {
						if(!this.accountform.term_use) {
							this.$refs.confirm.open('alert', '회원가입', '이용약관 및 개인정보처리방침에 동의해주세요.')
						}else if(!this.accountform.term_use_sw) {
							this.$refs.confirm.open('alert', '회원가입', '간편 회원 전환 처리에 동의해주세요.')
						}

					}
				}
			}else {
				this.$refs.confirm.open('alert', '회원가입', 'ID 중복체크를 해주세요.')
			}
		},
		login () {
      this.$refs.loading.start('인증메일 확인여부를 확인 중입니다.')
      checkAuthMail({ swId: this.swId }).then(response => {
        this.$refs.loading.end()
        if (response.rcode === 20000) {
          if (response.rdata.status === 20000) {
            if (response.rdata.auth) {
              this.$refs.confirm.open('confirm', '인증메일 확인여부', "이메일 인증이 완료되었습니다. 글로싸인엔터프라이즈 로그인 페이지로 이동하시겠습니까?").then(() => {
                this.$router.push({ name: 'login' })
              })
            } else {
              this.$refs.confirm.open('alert', '인증메일 확인여부', response.rdata.message)
            }
          } else {
            this.$refs.confirm.open('alert', '인증메일 확인여부', '인증메일 확인여부에 실패했습니다.')
          }
        } else {
          this.$refs.confirm.open('alert', '인증메일 확인여부', '인증메일 확인여부에 실패했습니다.')
        }
      }).catch(() => {
        this.$refs.loading.end()
        this.$refs.confirm.open('alert', '인증메일 확인여부', '인증메일 확인여부에 실패했습니다.')
      })
		},
		termUse () {
			if(this.accountform.term_use) {
				this.dialogAgree = true
			}
		},
		termUseSw () {
			if(this.accountform.term_use_sw) {
				this.dialogPass = true
			}
		}
  }
}

</script>
<style scoped>
</style>
